export default __webpack_public_path__ + "static/media/tsvetan_s.6f7216d9.jpg";